<template>
  <div>
    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="d-flex justify-space-between align-center headline white--text">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
              Cheques relacionados
            </div>
            <div class="d-flex">
              <BtnCreateDataExport 
                class="mx-3"
                api_model="Check" 
                action="Checks"
                :filters="filters"
              ></BtnCreateDataExport>
              <v-icon color="white" @click="reload">mdi-refresh</v-icon>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text>
            <v-tabs icons-and-text class="mb-5" grow color="none">
              <v-tabs-slider color="blue-grey"></v-tabs-slider>
              <v-tab :to="{name:'OpenChecks'}">
                CUSTÓDIA
                <v-icon :large="$route.name == 'OpenChecks'" color="blue">mdi-currency-usd</v-icon>
              </v-tab>
              <v-tab :to="{name: 'CompletedChecks'}">
                COMPENSADOS
                <v-icon :large="$route.name == 'CompletedChecks'" color="light-green">mdi-check-all</v-icon>
              </v-tab>
            </v-tabs>
            <router-view @doneFilter="handleDoneFilter"></router-view>
          </v-card-text>
        </v-card>
      </template>
    </index-card>
  </div>
</template>

<script>
export default {
  name: 'Checks',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    BtnCreateDataExport: () => import("@/components/data_export/BtnCreateDataExport.vue"),
  },
  data(){
    return {
      filters: {},
    }
  },
  methods: {
    handleDoneFilter(filter){
      this.filters = {...filter}
    },
    reload() {
      this.$router.go()
    },
  },
}
</script>
